import classnames from 'classnames';
import React from 'react';
import chatBubbleBigLeft from 'v2//images/chatBubbleBigLeft.svg';
import chatBubbleBigRight from 'v2//images/chatBubbleBigRight.svg';
import BackgroundImages, { BG_IMAGES } from '../Background/BackgroundImages';
import styles from './tabNosReults.module.scss';

interface TabNosReultsProps {
  message: string;
  showTopImage: boolean;
}

const TabNosReults = ({ message, showTopImage }: TabNosReultsProps) => {
  return (
    <>
      <BackgroundImages
        bottomImage={BG_IMAGES.bottomRightYellowBgImage}
        topImage={BG_IMAGES.topLeftPeachBgImage}
        showTopImage={showTopImage}
      />
      <img
        src={chatBubbleBigLeft}
        alt="chatBubbleTopImage"
        className={classnames('position-absolute', styles.chatBubbleTopImage)}
      />
      <img
        src={chatBubbleBigRight}
        alt="chatBubbleBottomImage"
        className={classnames(
          'position-absolute',
          styles.bubbleChatImageBottom
        )}
      />
      <div
        className={classnames(
          'h-75',
          'd-flex',
          'pt-5',
          'mt-5',
          'justify-content-center',
          'align-items-center',
          'position-relative'
        )}
      >
        <h1 className={classnames('mb-5 pb-5', styles.message)}>{message}</h1>
      </div>
    </>
  );
};

export default TabNosReults;
